import React, { useState } from 'react';

import InfoButton from '../InfoButton';
import Tabs from '../RankingTables/Tabs';
import Img from '../Img';

import style from './collapsibleSection.scss';
import { ratingTypes } from '../../utils/constants';

const CollapsibleSection = (props) => {
    const [closed, setClosed] = useState(false);
    const { children, title, infoText, className, headingClassName, showListSortButtons, sortAcceptanceType, 'data-testid': dataTestId } = props;

    return (
        <div className={`${style.collapsibleSection} mb40 ${className}`} data-testid={dataTestId || undefined}>
            <div className="d-flex flex-row bb aib">
                <div className={`flex-grow-1 ${headingClassName}`}>
                    <h4 className={`d-flex mb0 ${infoText ? 'aib' : 'aic'}`} data-testid={dataTestId && `${dataTestId}.title`}>{title}
                        {infoText && (
                            <React.Fragment>
                                <InfoButton
                                    hoverText={infoText}
                                >
                                    <Img alt="tooltip" src="/img/info-icon.svg" />
                                    <span className={`asfe ${style.infoLabel}`} data-testid={dataTestId && `${dataTestId}.info-label`}>{`Learn how players are accepted`}</span>
                                </InfoButton>
                            </React.Fragment>
                        )}
                        {showListSortButtons && (
                            <div className="ml32 mb0">
                                <Tabs
                                    tabs={[
                                        { name: 'WTA Alternate List Order', value: 'WTA', default: true },
                                        { name: `${ratingTypes.tennis} Alternate List Order`, value: ratingTypes.tennis },
                                    ]}
                                    tabHeaderClass={`bb ml16`}
                                    onTabChange={(val) => props.handleListOrderSelect(val)}
                                    activeTab={sortAcceptanceType || 'WTA'}
                                    data-testid={dataTestId && `${dataTestId}.sort-tabs`}
                                />
                            </div>
                        )}
                    </h4>
                </div>
                <span className="align-content-end" onClick={() => setClosed(!closed)} data-testid={dataTestId && `${dataTestId}.toggle-btn`}><i className={`far fa-chevron-${closed ? 'down' : 'up'}`} /></span>
            </div>
            {!closed && children}
        </div>
    );
};

export default CollapsibleSection;
